// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/billing/v1/list_subscription_plans.proto (package protos.vision.billing.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { SubscriptionPlan } from "./vision_billing_pb";
import { file_vision_billing_v1_vision_billing } from "./vision_billing_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/billing/v1/list_subscription_plans.proto.
 */
export const file_vision_billing_v1_list_subscription_plans: GenFile = /*@__PURE__*/
  fileDesc("Ci92aXNpb24vYmlsbGluZy92MS9saXN0X3N1YnNjcmlwdGlvbl9wbGFucy5wcm90bxIYcHJvdG9zLnZpc2lvbi5iaWxsaW5nLnYxIncKHExpc3RTdWJzY3JpcHRpb25QbGFuc1JlcXVlc3QSTQoGcGFyYW1zGAEgASgLMj0ucHJvdG9zLnZpc2lvbi5iaWxsaW5nLnYxLkxpc3RTdWJzY3JpcHRpb25QbGFuc1JlcXVlc3QuUGFyYW1zGggKBlBhcmFtcyK0AQodTGlzdFN1YnNjcmlwdGlvblBsYW5zUmVzcG9uc2USTgoGcmVzdWx0GAEgASgLMj4ucHJvdG9zLnZpc2lvbi5iaWxsaW5nLnYxLkxpc3RTdWJzY3JpcHRpb25QbGFuc1Jlc3BvbnNlLlJlc3VsdBpDCgZSZXN1bHQSOQoFcGxhbnMYASADKAsyKi5wcm90b3MudmlzaW9uLmJpbGxpbmcudjEuU3Vic2NyaXB0aW9uUGxhbmIGcHJvdG8z", [file_vision_billing_v1_vision_billing]);

/**
 * @generated from message protos.vision.billing.v1.ListSubscriptionPlansRequest
 */
export type ListSubscriptionPlansRequest = Message<"protos.vision.billing.v1.ListSubscriptionPlansRequest"> & {
  /**
   * @generated from field: protos.vision.billing.v1.ListSubscriptionPlansRequest.Params params = 1;
   */
  params?: ListSubscriptionPlansRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.billing.v1.ListSubscriptionPlansRequest.
 * Use `create(ListSubscriptionPlansRequestSchema)` to create a new message.
 */
export const ListSubscriptionPlansRequestSchema: GenMessage<ListSubscriptionPlansRequest> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_list_subscription_plans, 0);

/**
 * @generated from message protos.vision.billing.v1.ListSubscriptionPlansRequest.Params
 */
export type ListSubscriptionPlansRequest_Params = Message<"protos.vision.billing.v1.ListSubscriptionPlansRequest.Params"> & {
};

/**
 * Describes the message protos.vision.billing.v1.ListSubscriptionPlansRequest.Params.
 * Use `create(ListSubscriptionPlansRequest_ParamsSchema)` to create a new message.
 */
export const ListSubscriptionPlansRequest_ParamsSchema: GenMessage<ListSubscriptionPlansRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_list_subscription_plans, 0, 0);

/**
 * @generated from message protos.vision.billing.v1.ListSubscriptionPlansResponse
 */
export type ListSubscriptionPlansResponse = Message<"protos.vision.billing.v1.ListSubscriptionPlansResponse"> & {
  /**
   * @generated from field: protos.vision.billing.v1.ListSubscriptionPlansResponse.Result result = 1;
   */
  result?: ListSubscriptionPlansResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.billing.v1.ListSubscriptionPlansResponse.
 * Use `create(ListSubscriptionPlansResponseSchema)` to create a new message.
 */
export const ListSubscriptionPlansResponseSchema: GenMessage<ListSubscriptionPlansResponse> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_list_subscription_plans, 1);

/**
 * @generated from message protos.vision.billing.v1.ListSubscriptionPlansResponse.Result
 */
export type ListSubscriptionPlansResponse_Result = Message<"protos.vision.billing.v1.ListSubscriptionPlansResponse.Result"> & {
  /**
   * @generated from field: repeated protos.vision.billing.v1.SubscriptionPlan plans = 1;
   */
  plans: SubscriptionPlan[];
};

/**
 * Describes the message protos.vision.billing.v1.ListSubscriptionPlansResponse.Result.
 * Use `create(ListSubscriptionPlansResponse_ResultSchema)` to create a new message.
 */
export const ListSubscriptionPlansResponse_ResultSchema: GenMessage<ListSubscriptionPlansResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_list_subscription_plans, 1, 0);

